export default __webpack_public_path__ + "static/media/PROCESS_STEP4.225ea9f1.png";